import _ from "lodash";
import React from "react";
import { createPortal } from "react-dom";

import { connect } from "react-redux";

import { Global, css } from "@emotion/react";
import { bindActionCreators } from "@reduxjs/toolkit";

import { Alert } from "kit/alert";
import { HELPERS } from "styles-js";

import CustomerContext from "./contexts/CustomerContext";
import useRouteConfig from "./hooks/useRouteConfig";

import Confirm from "./containers/Confirm/Confirm.container";

import Footer from "./components/Footer/Footer.component.lazy";
import Header from "./components/Header/Header.component";
import MobileMenu from "./components/MobileMenu/MobileMenu.component";
import RequestsInProgressBar from "./components/RequestsInProgressBar/RequestsInProgressBar.component";
import CookieModal from "./components/CookieModal/CookieModal.component";
import PageViewTracker from "./components/PageViewTracker/PageViewTracker.component";
//import PekiChatbot from "./components/Chatbot/Chatbot.view";
import Chatyme from "./components/Chatyme/Chatyme.view";

import { appActions } from "./containers/App/App.slice";

import * as styles from "./MainLayout.styles";

type ComponentPropTypes = {
  state: any;
  actions: any;
  children: React.ReactNode;
}

function MainLayout({ state, actions, children }: ComponentPropTypes) {

  const activeRoute = useRouteConfig();

  const {
    isMobileMenuVisible,
    customerDetails,
    hasActiveLoan,
    initInProgress,
    /* hasUserLoggedIn, */
    requestsInProgress,
    token
    /* chatbotPayload */
  } = state;

  const {
    toggleMobileMenuVisibility,
    authUserLogout,
    applyCookiePermissions
  } = actions;

  return (
    <div id="wrapper" css={styles.wrapper}>

      <RequestsInProgressBar active={requestsInProgress} />

      <CustomerContext.Provider value={customerDetails}>
        <PageViewTracker>
          <MobileMenu
            handleToggleMobileMenuVisibility={toggleMobileMenuVisibility}
            isMobileMenuVisible={isMobileMenuVisible}
            handleUserLogout={authUserLogout}
            hasActiveLoan={hasActiveLoan} />
          <Header
            initInProgress={initInProgress}
            isMobileMenuVisible={isMobileMenuVisible}
            handleToggleMobileMenuVisibility={toggleMobileMenuVisibility}
            handleUserLogout={authUserLogout} />

          <div id="content" css={[
            styles.content,
            initInProgress && {
              minHeight: "100vh"
            }
          ]}>
            <main id="main" css={styles.main}>
              {/* Hidden "div" below added for testing purposes so that customerId can be found in automated tests */}
              <div
                id="customer-id"
                style={{ display: "none" }}>
                {_.get(customerDetails, "id")}
              </div>
              {children}
              <div id="main-portal-container" />
            </main>
          </div>
        </PageViewTracker>
      </CustomerContext.Provider>

      {!initInProgress && <Footer />}

      <CookieModal approveCookiePermissions={applyCookiePermissions} />

      {createPortal(<Confirm />, document.body)}
      {createPortal(<Alert />, document.body)}

      {
        /* !initInProgress && customerDetails && chatbotPayload && ( */
        !initInProgress && customerDetails && (
          <Chatyme
            customerDetails={customerDetails}
            /* contextValues={chatbotPayload}  */
            token={token} />
        )
      }

      {isMobileMenuVisible && (
        <Global styles={css({
          body: {
            overflow: "hidden"
          }
        })} />
      )}
      {activeRoute?.hideFooterOnMobile && (
        <Global styles={css({
          [HELPERS.media.smallerThan.sm]: {
            "#footer": {
              display: "none"
            }
          }
        })} />
      )}
      {activeRoute?.hideHeader && (
        <Global styles={css({
          "#header": {
            display: "none"
          }
        })} />
      )}
      {activeRoute?.hideFooter && (
        <Global styles={css({
          "#footer": {
            display: "none"
          }
        })} />
      )}

    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    state: {
      isMobileMenuVisible: state.app.isMobileMenuVisible,
      hasActiveLoan: state.app.hasActiveLoan,
      initInProgress: state.app.initInProgress,
      /* hasUserLoggedIn: state.app.hasUserLoggedIn, */
      customerDetails: state.app.memberDetails,
      requestsInProgress: state.shared.requestsInProgress
      /* chatbotPayload: state.app.chatbotPayload */
    }
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    ...appActions
  }, dispatch),
  dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
